import { KycProvider, type KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

export function getProviderType(kycInfo: KycResponse) {
  return kycInfo.activeProcess?.provider ?? KycProvider.PROVIDER_UNSPECIFIED;
}
